import React from 'react';
import { OnChangeCallback } from '../../../../../../util/UtilityTypes'
import BoolInput from '../../../../../misc/BoolInput';
import EnumInput from '../../../../../misc/EnumInput';
import * as GoogleUser from '../../../../../../util/GoogleUserExportTypes';
import { update } from '../../../../../../util/Helper';
import { useTranslation } from 'react-i18next';

interface GoogleUserStudentOrganizationalUnitPolicyProps {
    organizationalUnitPolicy: GoogleUser.StudentOrganizationalUnitPolicy
    configurationType: string
    disabled?: boolean
    onChange: OnChangeCallback<GoogleUser.StudentOrganizationalUnitPolicy>
    validation: string[]
}

const GoogleUserStudentOrganizationalUnitPolicy: React.FC<GoogleUserStudentOrganizationalUnitPolicyProps> = (props) => {
    const { t } = useTranslation(['configuration']);

    return (<>
        <BoolInput
            title={t('googleUserExport.OuPolicy.createMissing')}
            name={`${props.configurationType}-organizationalUnitPolicy.createMissingOrganisationalUnits`}
            value={props.organizationalUnitPolicy.createMissingOrganisationalUnits}
            updateValue={(n, v) => update(n, props.organizationalUnitPolicy, { createMissingOrganisationalUnits: v }, props.onChange)}
            disabled={props.disabled}
        />
        <EnumInput
            title={t('googleUserExport.OuPolicy.structure')}
            name={`${props.configurationType}-organizationalUnitPolicy.organisationalUnit`}
            value={props.organizationalUnitPolicy.organisationalUnit}
            options={GoogleUser.studentOrganizationalUnit.map(x => ({value: x, text: t(`googleUserExport.OuPolicy.studentOuOptions.${x}`)}) )}
            onChange={(n, v) => update(n, props.organizationalUnitPolicy, { organisationalUnit: v }, props.onChange)}
            disabled={props.disabled}
        />
        <EnumInput
            title={t('googleUserExport.OuPolicy.inactiveUsers')}
            name={`${props.configurationType}-organizationalUnitPolicy.suspendedUsersOrganisationalUnit`}
            value={props.organizationalUnitPolicy.suspendedUsersOrganisationalUnit}
            options={GoogleUser.studentSuspendedOrganizationalUnit.map(x => ({ value: x, text: t(`googleUserExport.OuPolicy.studentSuspendedOuOptions.${x}`) }))}
            onChange={(n, v) => update(n, props.organizationalUnitPolicy, { suspendedUsersOrganisationalUnit: v }, props.onChange)}
            disabled={props.disabled}
        />
    </>
    );
}

export default GoogleUserStudentOrganizationalUnitPolicy;
